import { InitialConfigType, LexicalComposer } from '@lexical/react/LexicalComposer';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { readNotification } from 'actions/notifications';
import LinkLookup from 'components/LinkLookup';
import moment from 'moment';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Notification } from 'types';
import LoadHtmlPlugin from 'utils/lexical/LoadHtmlPlugin';
import { MentionNode } from 'utils/lexical/Mentions/MentionNode';
import MentionsPlugin from 'utils/lexical/Mentions/MentionsPlugin';

type ComponentProps = {
  notification: Notification;
};

const NotificationListRow: React.FC<ComponentProps> = ({ notification }) => {
  const dispatch = useDispatch();

  const {
    created_by: createdBy,
    created_at: createdAt,
    envelope_action: action,
    payload,
    read,
  } = notification;

  const commentConfig: InitialConfigType = {
    namespace: 'comment-editor-row',
    nodes: [MentionNode],
    editable: false,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any): void => {
      throw error;
    },
  };

  const handleReadNotification = (): void => {
    dispatch(readNotification({ ...notification, read: true }));
  };

  return (
    <LinkLookup
      as="tr"
      routeName="envelope-detail"
      routeParams={{ envelopeId: payload.communication_envelope_uuid }}
      queryParams={{ envelopes__from_notifications: 'true' }}
      onClick={(): void => {
        handleReadNotification();
      }}
      className={`border-t border-litlingo-gray-1 table-row h-10 align-top ${
        !read
          ? 'bg-white hover:bg-litlingo-gray-1'
          : 'bg-litlingo-gray-0.5 hover:bg-litlingo-gray-1'
      }`}
    >
      <td className="table-wrapper__new-td">
        <div className="flex flex-col items-start gap-1 py-4 pl-6 text-body">
          {!read && <div className="w-2 h-2 rounded-full bg-litlingo-primary-80" />}
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div
          className="table-wrapper__new-cell-content flex flex-col gap-1 py-2.5 pr-4 text-body"
          style={{ height: 'auto' }}
        >
          <div className="flex overflow-hidden">
            <p>
              <b>{createdBy?.name}</b> tagged you
            </p>
          </div>
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="flex flex-row items-start gap-1 py-2.5 pr-4 text-body">
          <div className="flex overflow-hidden truncate">
            <LexicalComposer initialConfig={commentConfig}>
              <LoadHtmlPlugin edited={false} insertQuotes content={action?.value || ''} />
              <MentionsPlugin initialOptions={[]} />
              <RichTextPlugin
                contentEditable={
                  <ContentEditable
                    aria-placeholder="Hit 'Enter' to save"
                    placeholder=""
                    className=""
                  />
                }
                ErrorBoundary={LexicalErrorBoundary}
              />
            </LexicalComposer>
          </div>
        </div>
      </td>
      <td className="flex table-wrapper__new-td">
        <div className="flex flex-row items-start gap-1 py-2.5 pr-4 text-body">
          <div className="flex overflow-hidden">
            <div>{moment(createdAt).format('DD MMM yyyy, hh:mma')}</div>
          </div>
        </div>
      </td>
    </LinkLookup>
  );
};

export default NotificationListRow;
